import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardGuard } from '../core/guards/auth-guard.guard';
import { FeatureModulesComponent } from './feature-modules.component';

const routes: Routes = [
  {
    path: '',
    component: FeatureModulesComponent,
    children: [
      {
        path: 'home',
        canActivate: [AuthGuardGuard],
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'device-management',
        canActivate: [AuthGuardGuard],
        loadChildren: () => import('./device-management/device-management.module').then(m => m.DeviceManagementModule),
      },
      {
        path: 'template-management',
        canActivate: [AuthGuardGuard],
        loadChildren: () => import('./template-management-v1/template-management-v1.module').then(m => m.TemplateManagementV1Module),
      },
      {
        path: 'batch-management',
        canActivate: [AuthGuardGuard],
        loadChildren: () => import('./batch-management/batch-management.module').then(m => m.BatchManagementModule),
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeatureModulesRoutingModule { }
